<template>
  <div class="user-data-page clearfix d-lg-flex">
    <div class="illustration-wrapper d-flex align-items-center justify-content-between flex-column">
      <h3 class="font-rubik">&nbsp;<br> &nbsp;</h3>
      <div class="illustration-holder">
        <img src="../../assets/images/assets/ils_08.svg" alt="" class="illustration">
        <img src="../../assets/images/assets/ils_08.1.svg" alt="" class="shapes shape-one">
        <img src="../../assets/images/assets/ils_08.2.svg" alt="" class="shapes shape-two">
      </div>
    </div> <!-- /.illustration-wrapper -->

    <div class="form-wrapper">
      <div class="d-flex justify-content-between">
        <div class="logo">
          <router-link to="/">
            <img src="../../assets/images/RoboQuark.png" alt="">
          </router-link>
        </div>
        <router-link to="/" class="font-rubik go-back-button">Go to home</router-link>
      </div>
      <form @submit.prevent="register" class="user-data-form mt-30">
        <h2>Join with thousands of startup!</h2>
        <p class="header-info pt-30 pb-50">Already have an account?
          <router-link to="/login">Login</router-link>
        </p>

        <div class="row">
          <div class="col-12">
            <div class="input-group-meta mb-50">
              <label>User Name</label>
              <input v-model="user.username" required type="text" placeholder="Melvin.Carlson">
            </div>
          </div>
          <div class="col-12">
            <div class="input-group-meta mb-50">
              <label>Email</label>
              <input v-model="user.email" required type="email" placeholder="bolcovfed@ce.edu">
            </div>
          </div>
          <div class="col-12">
            <div class="input-group-meta mb-50">
              <label>Password</label>
              <input v-model="user.password" minlength="6" required :type="hidePassword ? 'text' : 'password'"
                placeholder="Enter Password" class="pass_log_id">
              <span class="placeholder_icon">
                <span :class="`passVicon ${hidePassword ? 'hide-pass' : ''}`" @click="handleHidePassword">
                  <img src="../../assets/images/icon/view.svg" alt="">
                </span>
              </span>
            </div>
          </div>
          <div class="col-12">
            <div class="input-group-meta mb-15">
              <!-- <label>Re-type Password</label> -->
              <!-- <input required :type="hideConfirmPassword ? 'text' : 'password'" 
              placeholder="Enter Password" class="pass_log_id"> -->
              <!-- <span class="placeholder_icon">
                <span :class="`passVicon ${hideConfirmPassword ? 'hide-pass' : ''}`" @click="handleHideConfirmPassword">
                  <img src="../../assets/images/icon/view.svg" alt="">
                </span>
              </span> -->
            </div>
          </div>
          <div class="col-12">
            <div class="agreement-checkbox d-flex justify-content-between align-items-center sm-mt-10">
              <div>
                <!-- <input required type="checkbox" id="agree_to_policy"> -->
                <!-- <label for="agree_to_policy">By clicking "SIGN UP" I agree to the Terms and Conditions and Privacy Policy.</label> -->
              </div>
            </div> <!-- /.agreement-checkbox -->
          </div>
          <div class="col-12">
            <button class="theme-btn-one mt-30 mb-50">Sign Up</button>
          </div>
          <div class="col-12">
            <p class="text-center font-rubik copyright-text">© Copyright 2024</p>
          </div>
        </div>
      </form>
    </div> <!-- /.form-wrapper -->
  </div>
</template>

<script>
// -------------Strapi-----------
import axios from 'axios';
// -------------Strapi-----------
export default {
  name: 'SignUpArea',
  data() {
    return {
      // -------------Strapi-----------
      user: {
        username: '',
        email: '',
        password: ''
      },
      // -------------Strapi-----------
      hidePassword: false,
      hideConfirmPassword: false,
    }
  },
  methods: {
    onSubmit() {
      console.log('Submitted');
    },
    handleHidePassword() {
      this.hidePassword = !this.hidePassword
    },
    // handleHideConfirmPassword() {
    //   this.hideConfirmPassword = !this.hideConfirmPassword
    // },
    // -------------Strapi-----------
    async register() {
      try {
        const response = await axios.post(process.env.VUE_APP_STRAPI_URL + 'api/auth/local/register', this.user);
        console.log('Registration successful', response);
        // Handle post-registration actions
        console.log(process.env.VUE_APP_STRAPI_URL + 'api/enrollments');
    
          const enrollmentResponse = await axios.post(process.env.VUE_APP_STRAPI_URL + 'api/enrolleds', {
            data: {
              username: response.data.user.username, // Use the ID of the newly registered user
              course: 1,
            }
          });
          console.log('Enrollment record created', enrollmentResponse);
          localStorage.setItem('jwt', response.data.jwt); // Store the token
        // Redirect or perform actions after successful login
        // Store user information
        const userInfo = response.data.user; // Assuming this contains the user information
        console.log(userInfo);
        localStorage.setItem('userInfo', JSON.stringify(userInfo)); // Convert object to string to store in localStorage


        console.log('Success');
        this.$router.push('/dashboard');
      } catch (error) {
        console.error('An error occurred during the registration or enrollment process', error);

        let errorMessage = 'An unknown error occurred.';
        if (error.response && error.response.data && error.response.data.message) {
          // If the error response has a message field, use it
          errorMessage = error.response.data.message;
        } else if (error.message) {
          // Otherwise, use the error's message field
          errorMessage = error.message;
        }

        alert(errorMessage);
      }
    }
    // -------------Strapi-----------
  },
}
</script>